export default __webpack_public_path__ + "b81a5e8fe2444f34c32bdc2e9253faec.svg";